import {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Collapse} from "reactstrap";
import {useSelector} from "react-redux";
import classnames from "classnames";
import WebPaths from "@router/paths/web";
import isUrlValid from "@utils/isUrlValid";
import {ProductTypes} from "@utils/types/ProductTypes";
import "./style.scss";

const Limit = true;
const LimitLevels = 4;

const MobileMenu = ({toggleMenu}) => {
    const [menu, setMenu] = useState(localStorage.getItem('menu') ? JSON.parse(localStorage.getItem('menu')) : []);
    const menuUpdate = useSelector(state => state.UI.general?.menu);
    const navigate = useNavigate();
    const location = useLocation();

    const MenuType = {
        ProductCategory: 1,
        InternalLink: 2,
        ExternalLink: 3
    }

    const MenuOpen = {
        InTab: 0,
        NewTab: 1
    }

    const MenuStatus = {
        Active: 0,
        UnClickable: 1,
        Invisible: 2
    }

    useEffect(() => {
        if (menuUpdate)
            setMenu(menuUpdate)
    }, [menuUpdate])

    const toggle = (menu_id) => {
        let index = menu.findIndex(f => f.id === menu_id);
        if (index >= 0) menu[index].collapse = !menu[index].collapse;
        setMenu([...menu]);
    }

    const hasChild = (id) => {
        return menu.filter(f => f.parentId === id).length > 0
    }

    const handleUrl = (item, event) => {
        const handleNavigationType = (type, url) => {
            switch (type) {
                case MenuOpen.InTab:
                    if (isUrlValid(url))
                        window.location = item.url;
                    else
                        navigate(url);
                    break;
                case MenuOpen.NewTab:
                    window.open(url, "_blank");
                    break;
            }
        }

        switch (parseInt(item.type)) {
            case MenuType.ProductCategory:
                handleNavigationType(item.openIn, WebPaths.category(item.category.slug));
                break;

            case MenuType.InternalLink:
                handleNavigationType(item.openIn, item.url);
                break;

            case MenuType.ExternalLink:
                handleNavigationType(item.openIn, item.url);
                break;
        }

        toggleMenu();
    }

    const handleCheckIsActive = (menu_item) => {
        const {url, category} = menu_item;
        if (url)
            return location.pathname === url || window.location.href === url;

        return (location.pathname === "/products" && location.search.includes(encodeURI(category.slug)));
    }

    const renderSubMenu = (parent_id = "main", limit = 1) => {
        return menu?.filter((item) => item.parentId === parent_id)?.sort((a, b) => a.index - b.index)?.map((menu_item, index) => {
            if (menu_item.status !== MenuStatus.Invisible) {
                return (
                    <div key={index} className={classnames("", {
                        "menu-mobile-main": parent_id === "main",
                    })}>
                        <div
                            className={classnames("menu-mobile-item", {
                                'lock': menu_item.status === MenuStatus.UnClickable,
                                'active': handleCheckIsActive(menu_item)
                            })}
                        >
                            <button
                                disabled={menu_item.status === MenuStatus.UnClickable}
                                className="navigation"
                                onClick={
                                    menu_item.status === MenuStatus.UnClickable ?
                                        () => {
                                        }
                                        :
                                        (event) => handleUrl(menu_item, event)
                                }
                            >
                            <span className={classnames("title", {'Open': menu_item.collapse})}>
                                {menu_item.title}
                            </span>
                            </button>

                            {(menu_item.canHaveChild && hasChild(menu_item.id)) &&
                                <button
                                    className="icon"
                                    onClick={() => toggle(menu_item.id)}
                                >
                                    <i className={classnames("my-auto float-right", {
                                        'fa fa-angle-left': !menu_item.collapse,
                                        'fa fa-angle-left open': menu_item.collapse
                                    })}/>
                                </button>
                            }
                        </div>

                        {(menu_item.canHaveChild && hasChild(menu_item.id)) &&
                            <Collapse className={classnames("menu-mobile-bg m-0")} isOpen={menu_item.collapse}>
                                {Limit ?
                                    limit < LimitLevels &&
                                    renderSubMenu(menu_item.id, (limit + 1))
                                    :
                                    renderSubMenu(menu_item.id)
                                }
                            </Collapse>
                        }
                    </div>
                )
            }
            return <></>;
        });
    };

    if (!menu?.length) return;

    return renderSubMenu();
};

export default MobileMenu;
